import { gu2px } from '@ux/theme-utils';
import { percentage } from '@ux/style-utils';

export default ({
  theme,
}) => {
  const {
    spacing,
  } = theme;

  return {
    default: {
      root: {
        overflow: 'hidden',
        paddingTop: gu2px(2, spacing),
      },

      item: {
        marginBottom: gu2px(2, spacing),
      },
    },

    tablet: {
      item: {
        display: 'flex',
        flexDirection: 'column',
        height: `calc(${percentage(100)} - ${gu2px(2, spacing)}px)`,
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/presentation/components/cookie-toggle-group/CookieToggleGroup.stylesheet.js